import { ProfileInterface, UserPermissions } from '@/shared/interfaces/profile.interface';

export interface State {
    token: string;
    status: string;
    user: {
        email: string,
        password: string,
    };
    profile: ProfileInterface;
    userPermissions: UserPermissions
}

export const state: State = {
    token: localStorage.getItem('user-token') || '',
    status: '',
    user: {
        email: '',
        password: '',
    },
    profile: {},
    userPermissions: {}
};
